type CheatShortcutEvent = Pick<
  KeyboardEvent,
  "altKey" | "code" | "ctrlKey" | "isComposing" | "key" | "metaKey" | "repeat"
>;

export function isCheatConsoleShortcut(e: CheatShortcutEvent): boolean {
  if (e.isComposing || e.repeat || !e.ctrlKey || e.altKey || e.metaKey) return false;
  return e.code === "Backquote" || e.key === "`";
}
